import { devEnvironment } from './environment.dev';
import { prodEnvironment } from './environment.prod';
import { stagingEnvironment } from './environment.staging';
import { testEnvironment } from './environment.test';
import { drEnvironment } from './environment.dr';

export interface Environment {
  name: 'production' | 'development' | 'test' | 'staging' | 'dr';
  auth0Domain: string;
  auth0ClientId: string;
  annotationStoreServiceBaseUrl: string;
  clientCalibrationBaseUrl: string;
  assetServiceBaseUrl: string;
  authorizationServiceBaseUrl: string;
  autoQaServiceBaseUrl: string;
  taskServiceBaseUrl: string;
  checkShaderErrors: boolean;
  draftSavePeriod: number;
  featureFlagServiceBaseUrl: string;
  outputMinHeight: number;
  previewWorkspacePointCloudAssetUrl: string;
  targetEnhancedPointCount: number;
  samplingBackendServiceBaseUrl: string;
  samplingPortalServiceBaseUrl: string;
  seedDataPointCloudTaskId: string;
  seedDataSensorFusionTaskId: string;
  settingsServiceBaseUrl: string;
  sh3BaseUrl: string;
  shouldDebounceRendering: boolean;
  shouldForceWebglContextLoss: boolean;
  shouldMakeHackyStoreForImageAnnotationTests: boolean;
  shouldSendDebugLogs: boolean;
  shouldSendErrorsToRollbar: boolean;
  shouldShowAddRandomShapes: boolean;
  shouldUseSegmentTracker: boolean;
  shouldUseResizeObserver: boolean;
}

export let environment: Environment;

switch (window.ENV) {
  case undefined:
    throw new Error('window.ENV not defined!');
  case 'production':
    environment = prodEnvironment;
    break;
  case 'test':
    environment = testEnvironment;
    break;
  case 'development':
    environment = devEnvironment;
    break;
  case 'dr':
    environment = drEnvironment;
    break;
  default:
    environment = stagingEnvironment;
    break;
}

if (window.workspaceConfig !== undefined) {
  environment.annotationStoreServiceBaseUrl =
    window.workspaceConfig.annotationStoreServiceBaseUrl + '/v1';
  environment.assetServiceBaseUrl = window.workspaceConfig.assetServiceBaseUrl;
  environment.authorizationServiceBaseUrl =
    window.workspaceConfig.authorizationServiceBaseUrl;
  environment.autoQaServiceBaseUrl =
    window.workspaceConfig.autoQaServiceBaseUrl;
  environment.clientCalibrationBaseUrl =
    window.workspaceConfig.clientCalibrationBaseUrl + '/api/v0';
  environment.featureFlagServiceBaseUrl =
    window.workspaceConfig.featureFlagServiceBaseUrl + '/v2.0';
  environment.samplingBackendServiceBaseUrl =
    window.workspaceConfig.samplingBackendServiceBaseUrl;
  environment.samplingPortalServiceBaseUrl =
    window.workspaceConfig.samplingPortalServiceBaseUrl;
  environment.taskServiceBaseUrl =
    window.workspaceConfig.taskServiceBaseUrl + '/api/v0';
  environment.settingsServiceBaseUrl =
    window.workspaceConfig.settingsServiceBaseUrl + '/api/v0';
  environment.sh3BaseUrl = window.workspaceConfig.sh3BaseUrl;
}
